<template>
    <v-layout row wrap>

        <v-flex xs12>
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{'Equipment plots'|translate}}
                    <v-spacer></v-spacer>
                    <equipment-context-menu :equipment="equipment" :date-range="dateRange"
                                            fault model-summary notification-breakdown equipment-summary
                    >
                        <v-list-tile  @click="exportAll()">
                            <v-list-tile-title>{{'Export all as PDF'|translate}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile  v-if="equipment" @click="handleMaintenanceClick">
                            <v-list-tile-title>{{'Create Maintenance Record'|translate}}</v-list-tile-title>
                        </v-list-tile>
                    </equipment-context-menu>
                    <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"></fault-record-dialog>
                </v-card-title>
                <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <date-range-selector class="mr-4" v-model="dateRange" @change="handleDateChange()" ></date-range-selector>
                        <equipment-selector v-on:ect="handleDateChange()" v-model="equipment"></equipment-selector>
                    </v-flex>
                    <v-flex xs12 v-show="loading">
                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </v-flex>
                    <v-flex xs12 v-if="!loading&&fullVariableList">
                        <data3-chart v-for="(unitVars,unitName) in fullVariableList" :key="unitName"
                                     :layout-overrides="{height:300,margin:layoutOverrides.margin,shapes:layoutOverrides.shapes,yaxis:{title:unitName,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                                     :on-only="false"
                                     :x-axis="'timestamp'"
                                     ref="plots"
                                     just-plot
                                     disable-responsive
                                     :show-export="false"
                                     :data-payload="unitVars"
                                     :date-range="dateRange"></data3-chart>
                    </v-flex>
                </v-layout>


                </v-card-text>
            </v-card>
        </v-flex>

    </v-layout>
</template>

<script>
    import exportAllToPDF from '../components/mixins/exportAllToPDF'
    import Plotly from 'plotly.js/dist/plotly'
    import DateRangeSelector from "../components/DateRangeSelector";
    import moment from 'moment'
    import EquipmentSelector from "../components/EquipmentSelector";
    import FaultRecordDialog from "../components/FaultRecordDialog";
    import EquipmentContextMenu from "../components/EquipmentContextMenu";
    import Data3Chart from "../components/Data3Chart";
    import {mapGetters} from "vuex";
    export default {
        name: 'EquipmentPlots',
        components: {DateRangeSelector,EquipmentSelector,FaultRecordDialog,EquipmentContextMenu,Data3Chart},
        mixins:[exportAllToPDF],
        computed: {
            ...mapGetters([
                'hiddenPointsConfig',
            ]),
        },
        data () {
            return {
                loading:true,
                rule:null,
                equipment:null,
                dateRange: {start: null, end: null},
                equipmentName: null,
                faultDesc: null,
                maintenanceDialog: false,
                maintenanceItem: null,
                highlightTime:null,
                relevantVariables:null,
                faultName:null,
                variableList:[],
                layoutOverrides:{},
                layout1:null,
                data1:null,
                timeout:null,
                points:[],
                plots:[],
                allVars:null,
                fullVariableList:{},
            }
        },
        watch: {
            equipment(){
                let me=this
                setTimeout(function(){ me.initPlotlySync()}, 2000);
            }
        },
        methods:{
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            relayout(ed) {
                let plots=[]
                for (let item of this.$refs.plots){
                    if (item.$refs.plotly){
                        plots.push(item.$refs.plotly.$refs.container)
                    }
                }
                for (let plot of plots){
                    if(plot.layout) {
                        let x = plot.layout.xaxis;
                        if (x.range[0] !== ed["xaxis.range[0]"] || x.range[1] !== ed["xaxis.range[1]"]) {
                            plot.relayout(ed);
                        }
                    }
                }
            },
            initPlotlySync(){
                let plots=[]
                let me=this;
                if(Object.keys(me.fullVariableList).length>0){
                    if(!this.$refs.plots||this.$refs.plots.length<this.fullVariableList.length){
                        setTimeout(function(){ me.initPlotlySync()}, 2000);
                    } else {
                        for (let item of this.$refs.plots){
                            if (item.$refs.plotly){
                                plots.push(item.$refs.plotly.$refs.container.$el)
                            }
                        }
                        me.plots=plots;
                        plots.forEach(div => {
                            if(div.on) {
                                div.on("plotly_relayout", ed => {
                                    if (!ed.autosize) {
                                        let newl = {
                                            "xaxis.range[0]": div.layout.xaxis.range[0],
                                            "xaxis.range[1]": div.layout.xaxis.range[1],
                                        }
                                        me.relayout(newl);
                                    }
                                });
                            }
                        });
                    }
                }

            },
            handleMaintenanceClick(){
                let startDate=this.dateRange.start
                let endDate=this.dateRange.end
                let newmr={
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment': this.equipment,
                    'maintenance_date_from': startDate,
                    'maintenance_date_to': endDate,
                    'maintenance_label':this.equipment,
                    'url': '/equipment-plots'+window.location.search
                }
                this.maintenanceItem={...newmr}
                this.maintenanceDialog=true
            },
            jumpToNotification(value,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.dateRange.start,
                        rangeEnd: this.dateRange.end,
                    }
                }
                output.query[facet]=value
                this.$router.push(output)
            },
            updateQueryString () {
                if(this.$router.currentRoute.name==="equipment-plots"){
                    this.$router.replace({
                        path: '/equipment-plots',
                        query: {
                            rangeStart: this.dateRange.start,
                            rangeEnd: this.dateRange.end,
                            equipment: this.equipment
                        }
                    }).catch(err => {})
                }
            },
            handleDateChange(){
                this.updateQueryString()
              this.renderPlots()
            },

            doInitialReload(){
                let me=this;
                if(!me.$refs.feplot){
                    setTimeout(function(){ me.doInitialReload()}, 3000);
                } else {
                    Plotly.relayout(me.$refs.feplot.$refs.container,{
                        'xaxis.autorange': true
                    })
                }

            },

            async renderPlots(){
                if(!this.equipment){
                    return
                }
                let me=this;
                me.loading=true
                me.data1=null
                let foundEquipment=null

                for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    if (this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name===this.equipment){
                        foundEquipment = this.$store.state.pointsListStore.pointsList.equipment_details[i];
                        this.allVars=this.$store.state.pointsListStore.pointsList.sensors[i]
                        break
                    }
                }
                if (this.hiddenPointsConfig){
                    let pointsToHide=[]
                    if (this.hiddenPointsConfig[foundEquipment.equipment_type]){
                        pointsToHide=pointsToHide.concat(this.hiddenPointsConfig[foundEquipment.equipment_type])
                    }
                    if (this.hiddenPointsConfig['*']){
                        pointsToHide=pointsToHide.concat(this.hiddenPointsConfig['*'])
                    }
                    this.allVars=this.allVars.filter(x=>!pointsToHide.includes(x))
                }
                if(this.allVars){
                    let newVarList={};
                    for (let varName of this.allVars){
                        let unit = this.getUnit(varName)
                        if (!newVarList[unit]) {
                            newVarList[unit] = [];
                        }
                        newVarList[unit].push({
                            'filters': {
                                equipment_name: this.equipment,
                                sensor_name: varName,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            seriesOverrides:{
                                type:'scatter',
                                opacity:1,
                                xbins: {
                                    size: 1
                                }
                            },
                        })
                    }
                    this.fullVariableList=newVarList
                }
                this.layoutOverrides={
                    title:"Relevant variables",
                    xaxis: {
                        title: '',
                    },
                    yaxis:{
                        fixedrange: true
                    },
                    margin:{
                        t: 30,
                        b:0
                    },
                    height:300,
                    showlegend:true,
                    legend: {
                        orientation:'h',
                        y: -0.2
                    },
                    hoverlabel: {
                        namelength: -1
                    },
                    hovermode:"x",
                    shapes: this.highlightTime ? [
                        {
                            type: 'line',
                            x0:this.highlightTime,
                            y0: 0,
                            x1: this.highlightTime,
                            y1: 1,
                            yref: 'paper',
                            line:{
                                color: 'red',
                                width: 4,
                            }
                        }
                    ] : [],
                }
                this.loading=false
                setTimeout(function(){ me.initPlotlySync() }, 2000);
            },
            async exportAll(){
                let plots=[...this.$refs.plots]
                if(this.$refs.rvplot){
                    plots.unshift(this.$refs.rvplot)
                }
                if(this.$refs.feplot){
                    plots.unshift(this.$refs.feplot)
                }
                let title=this.equipment+"="+this.dateRange.start
                await this.exportAllItems(plots,title);
            },
            getUnit(varName){
                for (let point of this.$store.state.pointsListStore.pointsList.points_list){
                    if(point.sensor_name===varName&&point.equipment_name===this.equipment){
                        if(point.unit){return point.unit}
                        break
                    }
                }
                if(varName.toLowerCase().includes("tem")){
                    return "°C"
                } else if(varName.toLowerCase().includes("press")){
                    return "kPa"
                } else if(varName.toLowerCase().includes("status")){
                    return "status"
                } else if(varName.toLowerCase().includes("_hr")){
                    return "hour"
                }
                return "";
            }
        },
        async beforeMount(){
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            this.equipment = _.get(this.$route.query, 'equipment', null)
            let rangeStart = _.get(this.$route.query, 'rangeStart', null)
            let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
            if (!!rangeStart) {
                this.dateRange = {start: rangeStart, end: rangeEnd}
            } else if(maxDate){
                this.dateRange={
                    start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                    end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
                }
            }
            this.renderPlots()
        },

    }
</script>
